/* zb: muestra productos distintos y en orden aleatorio cada vez que se recarga
   una pagina de categoria (coleccion) "normal", y tambien al usar el boton
   "Ver mas" (paginacion tipo show_more) para pasar a la pagina 2, 3, etc.
   - Solo actua sobre la grilla estandar de coleccion (#CollectionProductGrid /
     ul#main-collection-product-grid). No toca resultados de busqueda ni los
     carruseles de producto de la home (esos no tienen estos atributos data-zb-*).
   - El Liquid marca la grilla con data-zb-loading cuando va a ser reemplazada:
     el CSS la oculta (con un esqueleto encima) para que nunca se vean los
     productos originales. Este script quita la marca al mostrar los aleatorios.
   - Para que salga lo antes posible:
       1. prefetch(): el snippet lo llama inline ANTES de la grilla, asi la
          pagina al azar se empieza a pedir mientras el navegador sigue leyendo
          el HTML (no se espera a DOMContentLoaded).
       2. run(): el snippet lo llama inline justo DESPUES del </ul>.
       3. Al terminar de armar el pool se guarda en localStorage (30 min) una
          tanda aleatoria para la PROXIMA visita: desde la segunda carga los
          productos aleatorios salen al instante, sin esperar la red.
   - Si la primera pagina tarda mas de FIRST_PAGE_TIMEOUT, se muestran los
     productos que ya vinieron en el HTML, mezclados, para no dejar la grilla vacia.
   - Si hay filtros u orden activos no hace nada (comportamiento normal de
     Shopify). Otros parametros como page o utm_* no bloquean.
   - Una vez se muestran todos los productos del pool (maximo 150), se oculta
     el boton "Ver mas" en lugar de seguir cargando secuencialmente.
   - Si la grilla se vuelve a renderizar por AJAX (filtros del tema), se
     re-inicializa sobre la nueva grilla si corresponde. */
(function () {
	'use strict';

	if (window.zbRandomGrid) return; // por si el script se incluye dos veces

	var MAX_POOL = 150;
	var FIRST_PAGE_TIMEOUT = 3000;
	var LISTING_SEL = 'ul#main-collection-product-grid';
	var CACHE_PREFIX = 'zbRandNext:v1:';
	var CACHE_INDEX = 'zbRandNext:index';
	var CACHE_TTL = 30 * 60 * 1000;
	var CACHE_MAX_COLLECTIONS = 4;
	var CACHE_MAX_CHARS = 1500000;

	var state = null; // instancia activa (la grilla que esta en pantalla)
	var pre = null; // pedido adelantado por prefetch()

	function shuffle(array) {
		for (var i = array.length - 1; i > 0; i--) {
			var j = Math.floor(Math.random() * (i + 1));
			var tmp = array[i];
			array[i] = array[j];
			array[j] = tmp;
		}
		return array;
	}

	function listItems(listing) {
		return Array.prototype.slice.call(listing.children).filter(function (el) {
			return el.tagName === 'LI';
		});
	}

	function productId(li) {
		var el = li.querySelector('[data-product-id]');
		return el ? el.getAttribute('data-product-id') : null;
	}

	function extractItems(html) {
		try {
			var doc = new DOMParser().parseFromString(html, 'text/html');
			var listing = doc.querySelector(LISTING_SEL);
			return listing ? listItems(listing) : [];
		} catch (e) {
			return [];
		}
	}

	function fetchPage(sectionId, page) {
		var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + page;
		return fetch(url, { credentials: 'same-origin' })
			.then(function (res) {
				return res.ok ? res.text() : '';
			})
			.then(function (html) {
				return html ? extractItems(html) : [];
			})
			.catch(function () {
				return [];
			});
	}

	// Orden o filtros activos en la URL. Los filtros vacios (el tema manda
	// filter.v.price.gte= y filter.v.price.lte= sin valor) no cuentan.
	// Ojo: params.keys() es un iterador, no un array; por eso se usa forEach.
	function hasBlockingParams() {
		var blocking = false;
		new URLSearchParams(window.location.search).forEach(function (value, key) {
			if (key === 'sort_by' || key === 'q' || (key.indexOf('filter.') === 0 && value !== '')) blocking = true;
		});
		return blocking;
	}

	// la instancia sigue siendo la grilla que esta en pantalla
	function isActive(s) {
		return state === s && document.body.contains(s.listing);
	}

	/* ── cache de la proxima tanda (localStorage) ─────────────────────────── */

	function cacheKey(perPage, total) {
		return CACHE_PREFIX + window.location.pathname + ':' + perPage + ':' + total;
	}

	function readCache(key) {
		try {
			var raw = window.localStorage.getItem(key);
			if (!raw) return null;
			var data = JSON.parse(raw);
			if (!data || !data.t || Date.now() - data.t > CACHE_TTL || !data.html || !data.html.length) return null;
			return data.html;
		} catch (e) {
			return null;
		}
	}

	function writeCache(key, htmlList) {
		try {
			var raw = JSON.stringify({ t: Date.now(), html: htmlList });
			if (raw.length > CACHE_MAX_CHARS) return;
			var index = [];
			try {
				index = JSON.parse(window.localStorage.getItem(CACHE_INDEX) || '[]') || [];
			} catch (e) {}
			index = index.filter(function (k) {
				return k !== key;
			});
			index.push(key);
			while (index.length > CACHE_MAX_COLLECTIONS) window.localStorage.removeItem(index.shift());
			window.localStorage.setItem(key, raw);
			window.localStorage.setItem(CACHE_INDEX, JSON.stringify(index));
		} catch (e) {}
	}

	function htmlToNodes(htmlList) {
		var tpl = document.createElement('template');
		tpl.innerHTML = htmlList.join('');
		return listItems(tpl.content);
	}

	/* ── grilla ──────────────────────────────────────────────────────────── */

	function hideLoadMore() {
		var wrapper = document.querySelector('#CollectionProductGrid .pagination-page-infinite');
		if (wrapper) wrapper.style.display = 'none';
	}

	function reveal(listing) {
		listing.removeAttribute('data-zb-loading');
	}

	function notify(count, shown) {
		document.dispatchEvent(new CustomEvent('zb:random-products-rendered', { detail: { count: count, shown: shown } }));
	}

	function render(s, items) {
		var frag = document.createDocumentFragment();
		items.forEach(function (li) {
			frag.appendChild(li);
		});
		s.listing.appendChild(frag);
		s.shown += items.length;
		if (s.complete && s.shown >= s.pool.length) hideLoadMore();
		notify(items.length, s.shown);
	}

	function loadMore(s) {
		if (!s.started || s.waiting) return;

		var next = s.pool.slice(s.shown, s.shown + s.perPage);
		if (next.length) {
			render(s, next);
			return;
		}
		if (!s.complete) {
			// el resto del pool todavia se esta descargando: esperar y reintentar
			s.waiting = true;
			s.ready.then(function () {
				s.waiting = false;
				if (isActive(s)) loadMore(s);
			});
			return;
		}
		hideLoadMore();
	}

	function params(sectionId, total, perPage, currentPage) {
		var pagesNeeded = Math.ceil(Math.min(total, MAX_POOL) / perPage);
		return { sectionId: sectionId, total: total, perPage: perPage, currentPage: currentPage, pagesNeeded: pagesNeeded };
	}

	function samePrefetch(p) {
		return pre && pre.sectionId === p.sectionId && pre.total === p.total && pre.perPage === p.perPage && pre.currentPage === p.currentPage;
	}

	// Llamado inline por el snippet antes de la grilla: arranca la descarga ya.
	function prefetch(sectionId, total, perPage, currentPage) {
		try {
			if (typeof fetch !== 'function' || typeof DOMParser !== 'function' || hasBlockingParams()) return;
			total = parseInt(total, 10) || 0;
			perPage = parseInt(perPage, 10) || 0;
			currentPage = parseInt(currentPage, 10) || 1;
			if (!sectionId || !perPage || total <= perPage) return;

			var p = params(sectionId, total, perPage, currentPage);
			p.cached = readCache(cacheKey(perPage, total));
			p.randomPage = Math.floor(Math.random() * p.pagesNeeded) + 1;
			// con tanda guardada no hace falta apurar una pagina: el pool se arma despues
			p.randomReq = p.cached || p.randomPage === currentPage ? null : fetchPage(sectionId, p.randomPage);
			pre = p;
		} catch (e) {
			pre = null;
		}
	}

	function init(listing) {
		listing.setAttribute('data-zb-init', '');
		state = null; // una grilla nueva reemplaza a la anterior: lo pendiente de la vieja ya no aplica

		if (typeof fetch !== 'function' || typeof DOMParser !== 'function' || hasBlockingParams()) {
			reveal(listing);
			return;
		}

		var totalItems = parseInt(listing.getAttribute('data-zb-total-items'), 10) || 0;
		var perPage = parseInt(listing.getAttribute('data-zb-per-page'), 10) || 0;
		var currentPage = parseInt(listing.getAttribute('data-zb-current-page'), 10) || 1;
		var sectionId = listing.getAttribute('data-id');
		if (!perPage || totalItems <= perPage || !sectionId) {
			reveal(listing);
			return;
		}

		var p = params(sectionId, totalItems, perPage, currentPage);
		if (samePrefetch(p)) {
			p = pre;
		} else {
			p.cached = readCache(cacheKey(perPage, totalItems));
			p.randomPage = Math.floor(Math.random() * p.pagesNeeded) + 1;
			p.randomReq = null;
		}
		pre = null; // el prefetch se usa una sola vez

		var domItems = listItems(listing);
		if (!p.randomReq) p.randomReq = p.randomPage === currentPage ? Promise.resolve(domItems) : fetchPage(sectionId, p.randomPage);

		var s = (state = {
			listing: listing,
			perPage: perPage,
			pool: [],
			seen: {},
			shown: 0,
			started: false,
			complete: false,
			waiting: false,
			ready: null
		});

		function addUnique(target, items) {
			items.forEach(function (li) {
				var id = productId(li);
				if (id) {
					if (s.seen[id]) return;
					s.seen[id] = true;
				}
				target.push(li);
			});
			return target;
		}

		function start(items, skipPage) {
			if (s.started || !isActive(s)) return;
			s.started = true;
			clearTimeout(fallbackTimer);

			s.pool = shuffle(addUnique([], items));
			listing.innerHTML = '';
			render(s, s.pool.slice(0, perPage));
			reveal(listing);

			// resto del pool en segundo plano (reutiliza lo ya descargado o en curso)
			var reqs = [];
			for (var pg = 1; pg <= p.pagesNeeded; pg++) {
				if (pg === skipPage) continue;
				if (pg === currentPage) reqs.push(Promise.resolve(domItems));
				else if (pg === p.randomPage) reqs.push(p.randomReq);
				else reqs.push(fetchPage(sectionId, pg));
			}

			s.ready = Promise.all(reqs).then(function (results) {
				var rest = [];
				results.forEach(function (list) {
					addUnique(rest, list);
				});
				s.pool = s.pool.concat(shuffle(rest)).slice(0, MAX_POOL);
				s.complete = true;
				if (isActive(s) && s.shown >= s.pool.length) hideLoadMore();
				saveNext(s);
			});
		}

		// tanda al azar del pool completo para la proxima visita (al instante)
		function saveNext(s) {
			if (s.pool.length <= perPage) return;
			var pick = shuffle(s.pool.slice()).slice(0, perPage);
			writeCache(
				cacheKey(perPage, totalItems),
				pick.map(function (li) {
					return li.outerHTML;
				})
			);
		}

		var fallbackTimer = null;

		// 1) tanda guardada de la visita anterior: se muestra ya, sin esperar red
		if (p.cached) {
			var cachedNodes = htmlToNodes(p.cached);
			if (cachedNodes.length) {
				start(cachedNodes, null);
				return;
			}
		}

		// 2) primera visita: pagina al azar (ya pedida por prefetch) o, si tarda,
		//    los productos del HTML mezclados
		fallbackTimer = setTimeout(function () {
			start(domItems, currentPage);
		}, FIRST_PAGE_TIMEOUT);

		p.randomReq.then(function (items) {
			if (items.length) start(items, p.randomPage);
			else start(domItems, currentPage);
		});
	}

	function scan() {
		var listing = document.querySelector(LISTING_SEL + '[data-zb-loading]:not([data-zb-init])');
		if (listing) init(listing);
	}

	// "Ver mas": en fase de captura para adelantarse al handler jQuery del tema.
	// Solo se intercepta si la grilla activa sigue en la pagina (tras filtrar por
	// AJAX la grilla nueva la maneja el tema).
	document.addEventListener(
		'click',
		function (event) {
			var link = event.target.closest && event.target.closest('#CollectionProductGrid [data-infinite-scrolling]');
			if (!link || !state || !document.body.contains(state.listing) || hasBlockingParams()) return;

			event.preventDefault();
			event.stopImmediatePropagation();
			event.stopPropagation();

			loadMore(state);
		},
		true
	);

	var observing = false;
	function boot() {
		scan();
		var grid = document.getElementById('CollectionProductGrid');
		if (!observing && grid && typeof MutationObserver === 'function') {
			observing = true;
			new MutationObserver(scan).observe(grid, { childList: true, subtree: true });
		}
	}

	window.zbRandomGrid = { prefetch: prefetch, run: scan };

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
